document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.custom-gallery .wp-block-image').forEach(imageBlock => {
		const a = imageBlock.querySelector('a');
		const img = imageBlock.querySelector('img');

		if (!a || !img) return;

		if (!a.hasAttribute('data-lightbox')) {
			a.setAttribute('data-lightbox', 'gallery');
		}

		const altText = img.getAttribute('alt');

		if (altText && !a.hasAttribute('data-caption')) {
			a.setAttribute('data-caption', altText);
		}
	});
	if (window.Lightbox3 && window.Lightbox3.Lightbox) {
		window.Lightbox3.Lightbox.init();
	}
});
